$ = require('jquery')

module.exports =
	init: (payload) ->
		{$target} = payload

		$(document)
			# deaf
			.on('click', '.box-deaf__toggle', (e) ->
				e.preventDefault()
				$(@).parents('.box-deaf').toggleClass('is-open')
			)



// WEBPACK FOOTER //
// ./src/js/components/deaf.coffee